export default __webpack_public_path__ + "static/media/WonProposalLightActiv.f19578d5.svg";